import { Endpoint } from "rest-hooks";
export const typeOfChangeChanged = (data) => fetch(`/changecustomer/typeOfChangeChanged`, {
    method: "post",
    body: JSON.stringify(data),
    headers: {
        "content-type": "application/json"
    }
}).then(res => {
    return res;
});
const TypeOfChangeChangedEndpoint = new Endpoint(typeOfChangeChanged, {
    dataExpiryLength: 0,
    sideEffect: true
});
//# sourceMappingURL=TypeOfChangeChanged.js.map